import React, { Fragment, useCallback, useEffect, useState } from "react";
import "./WaitingRoomScreen.scss";
import { CheckValue } from "../../../services/CommonFunction";
import { changeVolume } from "../../../components/UI/InputRange/InputRange";
import StopWatch from "../ChildComponentUI/StopWatch/StopWatch";
import AVControls from "../ChildComponentUI/AVControls/AVControls";
import { TabLayoutUI } from "../ChildComponentUI/TabLayout/TabLayout";
import PinnedUsers from "../ChildComponentUI/PinnedUsers/PinnedUsers";
import Header from "../../../components/Header/Header";
import { selectIcon, SVG } from "../../../components/UI/selector";
import HocActivity from "../../LiveActivity/HocActivity";

const WaitingRoom = (props) => {
  const {
    totalSeconds,
    allUsers,
    tagUsers,
    required,
    coachData,
    selfData,
    userPin,
    zoom,
    zoomData,
    leaveMeeting,
    canvas,
    isHangoutRoom,
  } = props;
  const id = "meeting-audio";
  const [value, setValue] = useState(100);
  const [activeSpeakerText, setActiveSpeakerText] = useState(null);

  useEffect(() => {
    if (CheckValue(localStorage.getItem("setVolume"))) {
      changeVolume(parseInt(localStorage.getItem("setVolume"), 10), id, "null");
    } else {
      changeVolume(100, id, "null");
    }
    localStorage.removeItem("firstTime");
  }, []);

  useEffect(() => {
    if (
      zoomData.activeSpeaker &&
      allUsers.hasOwnProperty(zoomData.activeSpeaker.user_id)
    ) {
      if (allUsers[zoomData.activeSpeaker.user_id].me) {
        setActiveSpeakerText("You are speaking...");
      } else {
        setActiveSpeakerText(
          `${
            allUsers[zoomData.activeSpeaker.user_id].first_name
          } is speaking...`
        );
      }
    }
  }, [zoomData.activeSpeaker, allUsers]);

  const statsClick = useCallback(
    (status) => {
      if (zoom && (status === "audio" || status === "camera")) {
        zoom.enableDisableAudioCamera(status);
      }
    },
    [zoom]
  );

  return (
    <Fragment>
      <Header
        title={isHangoutRoom ? "Hangout" : "Waiting Room"}
        showLogo={false}
        showTitle={true}
        showStudio={false}
        showProfile={false}
      />
      <div className={"WaitingRoomScreen"}>
        <div className={"WRLeft"}>
          <div className="WRCoachVideoContainer box-layer1">
            <img className={"coachProfile"} src={coachData.profile_pic_thumb} />
            {canvas}
            {!isHangoutRoom ? (
              <div className={"pinnedUsersContainer"}>
                <PinnedUsers
                  tagUsers={tagUsers}
                  allUsers={allUsers}
                  userPin={userPin}
                />
              </div>
            ) : null}
          </div>
          <div className={"WRControlsParent box-layer1"}>
            <div></div>
            <div className={"cntrlParent"}>
              <AVControls
                id={id}
                value={value}
                required={required}
                controlClick={statsClick}
                zoom={zoom}
                zoomData={zoomData}
                selfData={selfData}
                soundSetting={"default"}
              />
            </div>
            {!isHangoutRoom ? (
              <LeaveHelpBtns leaveMeeting={leaveMeeting} />
            ) : (
              <div></div>
            )}
          </div>

          <div className={"WRFooter box-layer1"}>
            {isHangoutRoom ? (
              <LeaveHelpBtns leaveMeeting={leaveMeeting} />
            ) : null}
            {activeSpeakerText ? (
              <span className={"WRSpeaker"}>{activeSpeakerText}</span>
            ) : (
              <span></span>
            )}
            {!isHangoutRoom ? (
              <StopWatch duration={totalSeconds < 0 ? 0 : totalSeconds} />
            ) : null}
          </div>
        </div>
        <div className={"WRRight box-layer1"}>
          <TabLayoutUI {...props} />
        </div>
      </div>
    </Fragment>
  );
};

export default HocActivity(WaitingRoom);

const LeaveHelpBtns = ({ leaveMeeting }) => (
  <div className={"btnParent"}>
    <a href={localStorage.getItem("supportLink")} target="_blank">
      <SVG
        className={"helpBtn"}
        src={selectIcon("contactSupport")}
        height={24}
        width={24}
      />
    </a>
    <button className={"leaveBtn"} type={"button"} onClick={leaveMeeting}>
      Leave
    </button>
  </div>
);
